import { useState } from 'react';
import '../styles/gym-catalog.css';

const HUES = [8, 32, 96, 150, 194, 232, 268, 316];
const LOCAL_LOGO = /^\/assets\/gyms\/[a-f0-9]{64}\.webp$/;

/** Decorative next to the visible gym name. Never load arbitrary remote URLs. */
export function GymLogo({ name, logoUrl, size = 'picker' }: {
  name: string;
  logoUrl?: string | null;
  size?: 'small' | 'medium' | 'picker';
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const url = logoUrl && LOCAL_LOGO.test(logoUrl) && logoUrl !== failedUrl ? logoUrl : null;
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  const hue = HUES[Math.abs(hash) % HUES.length];
  const initials = [...name.matchAll(/[\p{L}\p{N}]+/gu)].slice(0, 2).map(m => m[0][0]).join('').toUpperCase() || '?';
  return (
    <span
      className={`gym-logo gym-logo--${size}${url ? '' : ' gym-logo--fallback'}`}
      aria-hidden="true"
      style={url ? undefined : { background: `hsl(${hue} 62% 30%)`, color: `hsl(${hue} 90% 86%)` }}
    >
      {url ? <img src={url} alt="" loading="lazy" decoding="async" onError={() => setFailedUrl(url)} /> : initials}
    </span>
  );
}
